(function () {
  "use strict";
  var FORM_ID = "152644";
  var QUOTE_PATH = "/pages/custom-logo-gifts-quote";
  var SUCCESS = /thanks for getting in touch|thank you.*(?:request|message)|successfully submitted/i;
  var started = false;

  function once(key) {
    try {
      if (sessionStorage.getItem(key)) return false;
      sessionStorage.setItem(key, "1");
    } catch (_) {}
    return true;
  }

  function context(locationName) {
    var path = location.pathname || "/";
    var product = path.match(/\/products\/([^/?#]+)/);
    return {
      event_version: "1",
      source_path: path,
      page_type: product ? "product" : (path.indexOf("/pages/") >= 0 ? "page" : "other"),
      locale: document.documentElement.lang || "unknown",
      cta_location: locationName || "unknown",
      product_handle: product ? product[1] : ""
    };
  }

  function publish(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === "function") {
        Shopify.analytics.publish(name, data);
      }
    } catch (_) {}
  }

  document.addEventListener("click", function (event) {
    var link = event.target.closest && event.target.closest("a[href]");
    if (!link) return;
    var href = link.getAttribute("href") || "";
    var section = link.closest("[data-zg-section]");
    var where = link.dataset.zgCtaLocation || (section && section.dataset.zgSection) || "page";
    if (link.dataset.zgEvent === "quote_cta" || href.indexOf(QUOTE_PATH) >= 0) {
      publish("zg_quote_cta_click", context(where));
    }
    if (/^mailto:/i.test(href)) publish("zg_email_click", context(where));
    if (/^(?:https?:\/\/)?(?:wa\.me|api\.whatsapp\.com)|^whatsapp:/i.test(href)) {
      publish("zg_whatsapp_click", context(where));
    }
  }, true);

  function form() {
    return document.querySelector(".globo-form-app");
  }

  function start(event) {
    var node = form();
    if (!node || !node.contains(event.target) || started) return;
    started = true;
    if (!once("zg_quote_form_start:" + location.pathname)) return;
    var data = context("quote_form");
    data.form_id = FORM_ID;
    publish("zg_quote_form_start", data);
  }

  document.addEventListener("input", start, true);
  document.addEventListener("change", start, true);

  function enumValue(node, name, allowed) {
    var field = node.querySelector('[name="' + name + '"]');
    var value = field ? String(field.value || "").trim().toLowerCase() : "";
    return allowed.indexOf(value) >= 0 ? value : "unknown";
  }

  function success() {
    var node = form();
    if (!node || !SUCCESS.test(node.innerText || "")) return;
    if (!once("zg_quote_submit_success:" + location.pathname)) return;
    var data = context("quote_form");
    data.form_id = FORM_ID;
    data.quantity_bucket = enumValue(node, "select-2", ["1-99", "100-499", "500-999", "1000+"]);
    data.customization_type = enumValue(node, "select-3", ["none", "logo", "colors", "packaging"]);
    data.product_style = enumValue(node, "select-1", ["standard", "premium", "custom"]);
    publish("zg_quote_submit_success", data);
  }

  new MutationObserver(success).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });
  success();
})();
